import { format } from 'date-fns';

export const getDate = (date: string, formatStr: string, skipError?: boolean) => {
  try {
    return format(new Date(date), formatStr);
  } catch (e) {
    return skipError ? '' : date;
  }
};
